import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  public alertTypes: any;
  public openFilter: boolean = false;
  @Output() enterEvent = new EventEmitter<boolean>();
  @Output() filtersEvent = new EventEmitter<any>();

  @Input() filters = {
    startDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 5,
      new Date().getDate()
    ).toISOString().slice(0, 10),
    endDate: new Date().toISOString().slice(0, 10),
    type: 0,
    state: ''
  }

  public status: any = ['IMPLEMENTED', 'PENDING', 'INFORMED'];
 
  constructor(
    private popoverController: PopoverController,
    private notificationsService: NotificationsService,
    public loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.getList();
  }

  getList() {
    this.loadingService.show();
    this.notificationsService.getAlertTypes().subscribe((data) => {
      this.alertTypes = data;
      this.loadingService.hide();
    });
  }

  close() {
    this.enterEvent.next(this.openFilter);
  }

  confirm(){
    this.filtersEvent.next(this.filters)
    this.enterEvent.next(this.openFilter);
  }
}
